module.exports = __webpack_public_path__ + "img/lv.6716e2a0.png";